<script>
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import Form from '@classes/Form'
import GenericAppBar from '@/src/components/layout/generic-app-bar.vue'
import { shareRecordService } from '@/src/services/safehaven/ShareRecordsService'

export default {
  components: {
    GenericAppBar,
  },
  page: {
    title: 'Telehealth',
    meta: [{ name: 'description', content: 'The Telehealth page.' }],
  },
  mixins: [layout, NavigateMixin],

  data() {
    return {
      form: new Form({
        recipientEmail: '',
      }),
      emailRule: [
        (v) => !!v || 'E-mail is required',
        (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || 'Invalid email address',
      ],
      DOBRule: [
        (v) => !!v || 'Required',
        (v) =>
          moment(v, 'MM/DD/YYYY', true)._isValid === true ||
          'Please enter valid date. Format required mm/dd/yyyy',
      ],

      date: '',
      currentDateWithFormat: new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, '-'),
      selectDate: null,
      recipientData: {},
      details: {
        org_id: null,
        recipient_information_id: null,
        recipient_email: '',
        senders_dob: '',
      },
      snackbar: false,
      snackbarMessage: '',
      loading: false,
    }
  },
  computed: {
    computedDateFormatted() {
      if (this.currentDateWithFormat === this.date) {
        return this.date ? moment(this.date).format('MM/DD/YYYY') : ''
      } else {
        return this.date ? moment(this.date).format('MM/DD/YYYY') : ''
      }
    },
    computedDateFormattedDatefns() {
      return this.date ? format(parseISO(this.date), 'MM/DD/YYYY') : ''
    },
    getEndDate() {
      var endDate = new Date(
        this.date.getFullYear(),
        this.date.getMonth() + 1,
        10
      )
      return endDate.toISOString().substr(0, 10)
    },
    disableBtn() {
      if (this.form.recipientEmail === '' || this.date === null) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    date(val) {},
  },

  mounted() {
    if (this.$route.params.recipientData) {
      localStorage.setItem(
        'recipientData',
        JSON.stringify(this.$route.params.recipientData)
      )
      this.recipientData = this.$route.params.recipientData
      this.details.recipient_information_id = this.recipientData.recipient_information_id
      this.details.org_id = this.recipientData.sender_org_id
    } else if (localStorage.getItem('recipientData')) {
      this.recipientData = JSON.parse(localStorage.getItem('recipientData'))
      this.senderName = this.recipientData.sender_name
      this.details.recipient_information_id = this.recipientData.recipient_information_id
      this.details.org_id = this.recipientData.sender_org_id
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async verifyRecipient() {
      try {
        var dateDOB = document.getElementById('pickerText').value
        this.loading = true
        this.details.recipient_email = this.form.recipientEmail
        this.details.senders_dob = moment(new Date(dateDOB)).format(
          'YYYY-MM-DD'
        )

        const tokenDetails = JSON.parse(
          localStorage.getItem('emailTokenDetails')
        )
        const userObj = JSON.parse(localStorage.getItem('auth.currentUser'))
        if (
          tokenDetails &&
          userObj &&
          userObj.user.email === this.form.recipientEmail
        ) {
          this.details.email_token = tokenDetails.token
          this.details.uid = tokenDetails.uid
          this.details.access_token = userObj.access
        }
        const responseData = await shareRecordService.verifyRecipientInfo(
          this.details
        )
        if (responseData.status === 200) {
          this.loading = false
          const userObj = JSON.parse(localStorage.getItem('auth.currentUser'))
          if (
            responseData.data.active_session &&
            userObj &&
            Object.keys(userObj).length !== 0
          ) {
            this.$router.push({
              name: 'safehaven-health-record',
              params: { showReceivedRecords: true },
            })
          } else {
            this.$router.push({
              name: 'shared-record-view',
              query: {
                responseData: responseData.data,
                recipientId: this.details.recipient_information_id,
              },
            })
          }
        }
      } catch (error) {
        this.loading = false
        console.error('Error:: ', error.response)
        this.snackbarMessage = error.response.data
        this.snackbar = true
      }
    },
  },
}
</script>

<template>
  <v-container>
    <GenericAppBar></GenericAppBar>
    <v-row :class="!notDesktop ? $style.rowContainer : $style.rowContainerMob">
      <v-col
        cols="12"
        sm="12"
        md="12"
        :lg="mobile ? 2 : 4"
        xl="2"
        :class="!mobile ? $style.paddingclss : ''"
        fill-height
      >
        <h3 class="peerHeading"
          >{{ recipientData.sender_name }} has shared health records with
          you.</h3
        >
        <div :class="$style.text">
          You have been granted limited access to view these health records.
        </div>
        <v-col cols="12" md="12" class="py-1 px-0 mb-3 mt-6">
          <label :class="$style.textLabelStyle">
            Enter your email <span :class="$style.mandatory"> * </span>
          </label>
          <v-text-field
            v-model="form.recipientEmail"
            class="mt-2"
            hide-details="auto"
            append-icon="mdi-email-outline"
            background-color="white"
            :rules="emailRule"
            outlined
            dense
          ></v-text-field>
        </v-col>

        <label :class="$style.textLabelStyle">
          Enter sender’s date of birth (mm/dd/yyyy)
          <span :class="$style.mandatory"> * </span>
        </label>
        <v-menu
          v-model="selectDate"
          :close-on-content-click="false"
          max-width="290"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              id="pickerText"
              slot="activator"
              :class="$style.dateInput"
              class="mt-2"
              :value="computedDateFormatted"
              :rules="DOBRule"
              append-icon="mdi-calendar"
              background-color="white"
              outlined
              dense
              v-on="on"
              @click:append="on.click"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @change="selectDate = false"
          ></v-date-picker>
        </v-menu>
        <div class="mt-6">
          <v-btn
            class="text-capitalize"
            :class="$style.fullbtn"
            :disabled="disableBtn"
            @click="verifyRecipient"
          >
            View Health Records
            <v-progress-circular
              v-if="loading"
              class="ml-4"
              :value="80"
              color="white"
              indeterminate
            ></v-progress-circular>
          </v-btn>
        </div>
      </v-col>
      <v-col
        v-if="!notDesktop"
        class="ml-6 mb-10"
        cols="12"
        sm="12"
        md="12"
        lg="6"
        xl="8"
      >
        <v-img
          :src="require('@assets/images/safehaven/SharingRecords02.svg')"
          width="400"
          height="280"
        ></v-img>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      content-class="body--text"
      height="65"
      color="background"
      :timeout="3000"
    >
      <div class="d-flex">
        <v-icon color="#ee6363" class="my-auto">mdi-close-circle</v-icon>
        <div class="my-auto ml-3">
          {{ snackbarMessage }}
        </div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn icon color="body" text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.rowContainer {
  justify-content: center;
  margin-top: 8%;
}

.rowContainerMob {
  align-items: center;
  justify-content: center;
  padding-top: 40%;
}
.clickable {
  display: inline-flex;
  padding-left: 32px;
  font-size: 14px;
  text-align: left;
  vertical-align: middle;
}
.btnClass {
  width: 240px;
  padding: 26px !important;
  font-size: 18px !important;
  font-weight: 600;
  color: #fff !important;
  text-transform: inherit;
  letter-spacing: inherit;
  background: #0476d9 !important;
  border: none;
  border-radius: 30px;
}
.imgclss {
  margin-top: 6px !important;
}
.link:hover,
a:visited {
  text-decoration: none;
}
.text {
  width: 80%;
  margin: 10px 0 0;
  font-size: 14px;
  line-height: 22.5px !important;
  color: #2c3a4b;
}
.title {
  font-size: 28px;
  font-weight: 400;
}

.fullbtn {
  width: 100%;
  padding: 26px !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: #fff !important;
  text-align: center;
  letter-spacing: 0;
  background: #0476d9 !important;
  border: none;
  border-radius: 30px;
}
.fullbtn:hover {
  text-decoration: none !important;
}
.paddingclss {
  margin-left: 32px;
}
.dateInput {
  cursor: pointer;
}
.mandatory {
  margin-bottom: 10px !important;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: #da1414;
}

.textLabelStyle {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  letter-spacing: 0.20000000298023224px;
}

@media screen and (max-width: 1263px) {
  .paddingclss,
  .clickable {
    padding-left: 0 !important ;
  }
  .text {
    width: 100%;
  }
}
@media screen and (max-width: 960px) {
  .fullbtn {
    width: 90%;
  }
}
@media screen and (max-width: 959px) {
  .paddingclss,
  .clickable {
    padding: 0 20px !important ;
  }
}
@media screen and (max-width: 599px) {
  .fullbtn {
    width: 100%;
    font-size: 14px;
  }
}
</style>

<style scoped>
.peerHeading {
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0;
}

.appoinment {
  font-size: 18px !important;
  font-weight: 700;
  line-height: 22.5px !important;
}
/deep/ .textField input::placeholder {
  color: #000 !important;
  opacity: 1;
}
/deep/
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  cursor: pointer !important;
}
/deep/ .v-input input {
  font-size: 14px !important;
  cursor: pointer !important;
}
/deep/ .v-input input::placeholder {
  color: #000 !important;
}
/deep/ .v-input {
  font-size: 14px !important;
}
/deep/ .v-list-item__title {
  font-size: 14px !important;
}
</style>
